import { Check, X } from 'lucide-react';

export const STEPS = [
  { key: 'won', label: 'À payer' },
  { key: 'payment_submitted', label: 'Paiement envoyé' },
  { key: 'paid', label: 'Confirmé' },
  { key: 'shipped', label: 'Expédiée' },
  { key: 'delivered', label: 'Livrée' },
];
export const STATUS_LABEL = { won: 'À payer', payment_submitted: 'Paiement envoyé', paid: 'Paiement confirmé', shipped: 'Expédiée — en route', delivered: 'Livrée', cancelled: 'Annulée' };
export const STATUS_TONE = {
  won: 'text-rose-300 border-rose-500/40 bg-rose-500/10',
  payment_submitted: 'text-amber-300 border-amber-500/40 bg-amber-500/10',
  paid: 'text-emerald-300 border-emerald-500/40 bg-emerald-500/10',
  shipped: 'text-[#F5D98B] border-[#E8B84A]/50 bg-[#E8B84A]/10',
  delivered: 'text-sky-300 border-sky-500/40 bg-sky-500/10',
  cancelled: 'text-slate-400 border-slate-600 bg-slate-800/40',
};

export function StatusPill({ status, testid }) {
  return <span data-testid={testid} className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-widest border ${STATUS_TONE[status] || STATUS_TONE.cancelled}`}>
    {status === 'shipped' && <span className="h-1.5 w-1.5 rounded-full bg-[#E8B84A] animate-pulse" />}{STATUS_LABEL[status] || status}
  </span>;
}

export function OrderTimeline({ status, testid }) {
  const idx = STEPS.findIndex((s) => s.key === status);
  const cancelled = status === 'cancelled';
  return (
    <div className="tl" data-testid={testid}>
      {STEPS.map((s, i) => {
        const done = !cancelled && i < idx; const current = !cancelled && i === idx;
        return (
          <div key={s.key} className={`tl-step ${done ? 'done' : ''} ${current ? 'current' : ''} ${cancelled && i === 0 ? 'cancelled' : ''}`}>
            <span className="tl-dot grid place-items-center">{done && <Check className="h-2.5 w-2.5 text-[#0b0f17]" strokeWidth={4} />}{cancelled && i === 0 && <X className="h-2.5 w-2.5 text-white" strokeWidth={4} />}</span>
            <div className="tl-label">{cancelled && i === 0 ? 'Annulée' : s.label}</div>
          </div>
        );
      })}
    </div>
  );
}
